module.exports = __webpack_public_path__ + "static/media/ToyotaType-Black.ff7f54df.otf";